import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../../environments/environment";

declare var require: any;
@Pipe({ name: "second_time", pure: false })
export class SecondToTime implements PipeTransform {
  transform(text: number): any {
    if (text) {
      let totalSeconds: any = text;
      const hours: any = Math.floor(totalSeconds / 3600);
      const minutes: any = Math.floor((totalSeconds - hours * 3600) / 60);
      let seconds: any = totalSeconds - hours * 3600 - minutes * 60;

      seconds = Math.round(seconds * 100) / 100;

      let result: any = hours < 10 ? "0" + hours : hours;
      let strings: any = "";
      if (hours > 0) {
        if (hours === 1) {
          result += " hr";
        } else {
          result += " hrs";
        }

        strings += result;
      }
      if (minutes > 0) {
        if (minutes === 1) {
          strings += " " + (minutes < 10 ? "0" + minutes : minutes) + " min";
        } else {
          strings += " " + (minutes < 10 ? "0" + minutes : minutes) + " mins";
        }
      }

      if (seconds > 0) {
        if (seconds === 1) {
          strings += " " + (seconds < 10 ? "0" + seconds : seconds) + " sec";
        } else {
          strings += " " + (seconds < 10 ? "0" + seconds : seconds) + " sec";
        }
      }
      return strings;
    } else {
      return "0 sec";
    }
  }
}

@Pipe({ name: "music_duration", pure: false })
export class MusicDuration implements PipeTransform {
  transform(text: number): any {
    if (text) {
      let totalSeconds: any = text;
      const hours: any = Math.floor(totalSeconds / 3600);
      const minutes: any = Math.floor((totalSeconds - hours * 3600) / 60);
      let seconds: any = totalSeconds - hours * 3600 - minutes * 60;
      seconds = Math.round(seconds * 100) / 100;
      let result: any = hours < 10 ? "0" + hours : hours;
      let strings: any = "";
      if (hours > 0) {
        if (hours === 1) {
          result += ":";
        } else {
          result += ":";
        }
        strings += result;
      }
      if (minutes > 0) {
        if (minutes === 1) {
          strings += "" + (minutes < 10 ? "0" + minutes : minutes) + ":";
        } else {
          strings += "" + (minutes < 10 ? "0" + minutes : minutes) + ":";
        }
      }
      if (seconds > 0) {
        if (seconds === 1) {
          strings += "" + (seconds < 10 ? "0" + seconds : seconds);
        } else {
          strings += "" + (seconds < 10 ? "0" + seconds : seconds);
        }
      }
      if (!seconds) {
        strings += "00";
      }
      return strings;
    } else {
      return "00:00";
    }
  }
}
